import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Box
} from '@mui/material';

const NuevoCliente = ({ open, onClose, onClienteCreado }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    nombre: '',
    apellido1: '',
    apellido2: '',
    telefono: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const clienteData = {
      nombre_cliente: formData.nombre,
      apellidos_cliente: `${formData.apellido1} ${formData.apellido2}`.trim(),
      telefono: formData.telefono || null  // Si está vacío, envíalo como `null`
    };
  
    try {
      const response = await fetch(`${apiUrl}/api/nuevocliente`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(clienteData)
      });
  
      const data = await response.json();
      
      if (!response.ok) throw new Error(data.message || 'Error al crear cliente');
  
      onClienteCreado({
        id_cliente: data.id_cliente,
        nombre: data.nombre_cliente,
        apellido: data.apellidos_cliente,
        telefono: data.telefono
      });
      
      onClose();
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Nuevo Cliente</DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ mt: 2 }}>
          <TextField
            fullWidth
            margin="normal"
            label="Nombre *"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
          />
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              fullWidth
              margin="normal"
              label="Primer Apellido *"
              name="apellido1"
              value={formData.apellido1}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Segundo Apellido"
              name="apellido2"
              value={formData.apellido2}
              onChange={handleChange}
            />
          </Box>
          
          <TextField
            fullWidth
            margin="normal"
            label="Teléfono (Opcional)"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            type="tel"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button 
  onClick={handleSubmit}
  variant="contained" 
  color="primary"
  disabled={!formData.nombre || !formData.apellido1 || !formData.apellido2} // Ahora apellido2 también es obligatorio
>
  Guardar
</Button>

      </DialogActions>
    </Dialog>
  );
};

export default NuevoCliente;
